import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrl: './image-gallery.component.scss',
    standalone: false
})

export class ImageGalleryComponent {
  @Input() images: any;
  @Input() displayImageDialog:boolean = false;
  @Output() visibleChangeUpdate = new EventEmitter();
  responsiveOptions: any[] = [
    { breakpoint: '1024px', numVisible: 5 }, { breakpoint: '768px', numVisible: 3 }, { breakpoint: '560px', numVisible: 1 }
  ];

  /**
   * 
   * @param $event 
   */
  visibleChange($event:boolean) {
    this.visibleChangeUpdate.emit()
  }
}